import { createSelector } from 'reselect'

import { selectPartner360Data } from './selectPartner360Data'

export const selectPartnerDataEntryId = createSelector(
  [selectPartner360Data],
  ({ entryId }) => entryId
)
